export const productsTranslations = {
  ua: {
    products: [
      {
        title: 'Системи для Приватних Будинків',
        description: 'Компактні та енергоефективні станції біологічної очистки PURA для котеджів і дач (від 4 до 10 осіб). Забезпечують стабільну роботу та не потребують складного обслуговування.'
      },
      {
        title: 'Рішення для Комерційних Об\'єктів',
        description: 'Великі системи очищення для готелів, баз відпочинку, малих підприємств та житлових комплексів. Розраховані до 50 мешканців з можливістю індивідуального проєктування.'
      },
      {
        title: 'Нестандартні Пластикові Вироби',
        description: 'Індивідуальні пластикові вироби за кресленнями та технічними вимогами замовника. Адаптація конструкції під конкретні умови монтажу й функції.'
      },
      {
        title: 'PURA-4',
        description: 'Продуктивність 0,6 м³ стічних вод на добу, що підходить для домогосподарства з 2–4 мешканцями. Конструкція оснащена кільцями жорсткості та передбачає простий, швидкий монтаж.'
      },
      {
        title: 'PURA-6',
        description: 'Продуктивність 0,8 м³ стічних вод на добу, що оптимально для домогосподарства з 4–6 мешканцями. Обладнана кільцями жорсткості та передбачає простий монтаж.'
      },
      {
        title: 'PURA-9',
        description: 'Продуктивність – 1,35 м³ стічних вод на добу, що підходить для домогосподарства з 6–9 мешканцями. Корпус має кільця жорсткості, завдяки чому витримує ґрунтовий тиск. Конструкція передбачає простий та швидкий монтаж без складних будівельних робіт.'
      }
    ]
  },
  en: {
    products: [
      {
        title: 'Systems for Private Houses',
        description: 'Compact and energy-efficient PURA biological treatment stations for cottages and dachas (from 4 to 10 people). Provide stable operation and do not require complex maintenance.'
      },
      {
        title: 'Solutions for Commercial Facilities',
        description: 'Large treatment systems for hotels, recreation centers, small businesses and residential complexes. Designed for up to 50 residents with the possibility of individual design.'
      },
      {
        title: 'Custom Plastic Products',
        description: 'Custom plastic products according to drawings and technical requirements of the customer. Adaptation of the design to specific installation conditions and functions.'
      },
      {
        title: 'PURA-4',
        description: 'Capacity of 0.6 m³ of wastewater per day, suitable for a household of 2-4 residents. The design is equipped with stiffening rings and provides simple, quick installation.'
      },
      {
        title: 'PURA-6',
        description: 'Capacity of 0.8 m³ of wastewater per day, optimal for a household of 4-6 residents. Equipped with stiffening rings and provides simple installation.'
      },
      {
        title: 'PURA-9',
        description: 'Capacity of 1.35 m³ of wastewater per day, suitable for a household of 6-9 residents. The body has stiffening rings, which allows it to withstand ground pressure. The design provides simple and quick installation without complex construction work.'
      }
    ]
  }
};
